<!--Code below renders a logo and copyright notice for the Mediae Latinitatis Lexicon Minus thesaurus.-->

<a (click)="openPopup()" (keydown.enter)="openPopup()" tabindex="0" class="brill-link">
    <img [src]="brillLogoPath" alt="{{'acta_lexicon_qualifiers_logo_tooltip' | i18next}}" />
</a>
<span class="copyright-notice">  
    {{'acta_lexicon_qualifiers_logo_copyright' | i18next}}
</span>